module.exports = __webpack_public_path__ + "static/media/revolver1.b28d66ad.png";